import useDeleteAdminOrganization from '../../api/useDeleteAdminOrganization';
import { AdminButton } from '../AdminButton';
import AdminErrorMessage from '../atoms/AdminErrorMessage';
import AdminModal from '../molecules/AdminModal';
import { useState } from 'react';

type AdminOrganizationDeleteModalProps = {
  open: boolean;
  onClose: () => void;
  organizationId: number | null;
  organizationName: string | null;
  onDeleted: () => void;
};

export default function AdminOrganizationDeleteModal({
  open,
  onClose,
  organizationId,
  organizationName,
  onDeleted,
}: AdminOrganizationDeleteModalProps) {
  const { mutateAsync: deleteOrganization, isPending } = useDeleteAdminOrganization();
  const [error, setError] = useState<string | null>(null);

  const handleDelete = async () => {
    if (!organizationId) return;
    try {
      setError(null);
      await deleteOrganization({ id: organizationId });
      onClose();
      onDeleted();
    } catch (err) {
      setError(err instanceof Error ? err.message : '削除に失敗しました');
    }
  };

  return (
    <AdminModal
      open={open}
      onClose={onClose}
      title="企業の削除"
      titleColor="text-[#ff4e4e]"
      maxWidth="max-w-[600px]"
      footer={
        <div className="flex items-center justify-end gap-4">
          <AdminButton label="キャンセル" variant="secondary" onClick={onClose} />
          <AdminButton
            label={isPending ? '削除中...' : '削除する'}
            variant="danger"
            disabled={isPending}
            onClick={handleDelete}
          />
        </div>
      }
    >
      <div className="py-9 text-center text-sm text-[#333]">
        {organizationName
          ? `本当に ${organizationName} を削除してもよろしいですか？`
          : '本当にこの企業を削除してもよろしいですか？'}
        <p className="mt-2 text-xs text-[#777]">
          この操作は取り消せません。関連するデータもすべて削除されます。
        </p>
      </div>
      <AdminErrorMessage message={error} />
    </AdminModal>
  );
}
